export enum FeatureKeys {
  INSTANCE_STOP_NONPII = 'INSTANCE_STOP_NONPII',
  INSTANCE_STOP_PII = 'INSTANCE_STOP_PII',
  INSTANCE_STOP_LIVE = 'INSTANCE_STOP_LIVE',
  INSTANCE_START_NONPII = 'INSTANCE_START_NONPII',
  INSTANCE_START_PII = 'INSTANCE_START_PII',
  INSTANCE_START_LIVE = 'INSTANCE_START_LIVE',
  PARALLEL_DR_NONPII = 'PARALLEL_DR_NONPII',
  PARALLEL_DR_PII = 'PARALLEL_DR_PII',
  PARALLEL_DR_LIVE = 'PARALLEL_DR_LIVE',
  JUMPBOX_NONPII = 'JUMPBOX_NONPII',
  JUMPBOX_PII = 'JUMPBOX_PII',
  JUMPBOX_LIVE = 'JUMPBOX_LIVE',
  COB_NONPII = 'COB_NONPII',
  COB_PII = 'COB_PII',
  COB_LIVE = 'COB_LIVE',
  RVT_TEST_NONPII = 'RVT_TEST_NONPII',
  RVT_TEST_PII = 'RVT_TEST_PII',
  SANITY_TEST_NONPII = 'SANITY_TEST_NONPII',
  SANITY_TEST_PII = 'SANITY_TEST_PII',
  SANITY_TEST_LIVE = 'SANITY_TEST_LIVE',
  EF_TEST_NONPII = 'EF_TEST_NONPII',
  DATABASE_SNAPSHOT_NONPII = 'DATABASE_SNAPSHOT_NONPII',
  DATABASE_SNAPSHOT_PII = 'DATABASE_SNAPSHOT_PII',
  DATABASE_SNAPSHOT_LIVE = 'DATABASE_SNAPSHOT_LIVE',
  DATABASE_ARCHIVE_LIVE = 'DATABASE_ARCHIVE_LIVE'
}





